export const en = {
    'confirm-delete': 'Are you sure you want to delete the negative keyword set?',
    copy: 'Copy',
    'create-success': 'The "{name}" negative keyword set has been created',
    'delete-error': 'An error occurred while deleting the "{name}" negative keyword set',
    'delete-success': 'The "{name}" negative keyword set has been deleted',
    'update-success': 'The "{name}" negative keyword set was changed'
};
